import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LineIcon from "assets/images/chatIcons/icon-line.png";

function LineMessenger() {
  const { language } = useParams();

  const LINE_URLS = {
    th: "https://line.me/R/ti/p/@000egqip?from=page&searchId=000egqip",
    TW: "https://line.me/R/ti/p/@557dhtaa?from=page&searchId=557dhtaa",
  };

  const [currentLanguage, setCurrentLanguage] = useState(
    language || sessionStorage.getItem("I18N_LANGUAGE"),
  );

  useEffect(() => {
    const checkLanguageUpdate = () => {
      const storedLanguage = sessionStorage.getItem("I18N_LANGUAGE");
      setCurrentLanguage(language || storedLanguage);
    };

    const intervalId = setInterval(checkLanguageUpdate, 500);

    return () => clearInterval(intervalId);
  }, [language]);

  const LINE_MESSENGER_URL = LINE_URLS[currentLanguage];

  useEffect(() => {
    if (LINE_MESSENGER_URL) {
      const lineButton = document.createElement("div");
      lineButton.id = "line-widget";
      lineButton.style.position = "fixed";
      lineButton.style.bottom = "-100px";
      // lineButton.style.bottom = "100px";
      lineButton.style.right = "20px";
      lineButton.style.zIndex = "1000";
      lineButton.style.cursor = "pointer";
      lineButton.style.transition = "bottom 0.5s ease";

      // Create an image or icon element for the Line button
      const lineIcon = document.createElement("img");
      lineIcon.src = LineIcon;
      lineIcon.alt = "Line Messenger";
      lineIcon.style.width = "60px";
      lineIcon.style.height = "60px";
      
      lineButton.appendChild(lineIcon);

      // Add click event to open the Line Messenger URL in a new tab
      lineButton.addEventListener("click", () => {
        window.open(LINE_MESSENGER_URL, "_blank");
      });

      document.body.appendChild(lineButton);

      setTimeout(() => {
        lineButton.style.bottom = "100px";
      }, 1000);

      return () => {
        const existingButton = document.getElementById("line-widget");
        if (existingButton) {
          document.body.removeChild(existingButton);
        }
      };
    }
  }, [LINE_MESSENGER_URL]);

  if (!LINE_MESSENGER_URL) {
    return null;
  }

  return null;
}

export default React.memo(LineMessenger);
